//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import _ from 'lodash'
export default {
  name: 'search',
  props: {
    searchData: {
      required: true,
      type: Array
    }
  },
  data () {
    return {
      formData: {
      },
      loading: false,
      showPropLength: 0
    }
  },
  created () {
    this.searchData.forEach(item => {
      this.showPropLength = 0
      if (item.type === 'cascader' || item.type === 'daterange') {
        this.$set(this.formData, item.prop, [])
        this.showPropLength++
      } else if (item.type === 'text') {
        this.$set(this.formData, item.prop, item.value)
      } else {
        this.$set(this.formData, item.prop, '')
        this.showPropLength++
      }
    })
  },
  methods: {
    getData () {
      let data = this.unformatFormData()
      return data
    },
    setData (val) {
      this.formData = val
    },
    emitEvent (item) {
      if (item.callbackMethodName) {
        this.$parent.$emit(item.callbackMethodName, this.formData)
      }
      this.$parent.$emit('changeSearchData', this.formData)
    },
    search () {
      let data = this.unformatFormData()
      this.$emit('search', data)
    },
    unformatFormData () {
      let formData = {}

      formData = _.cloneDeep(this.formData)
      for (let item in this.formData) {
        let isCascader = this.searchData.some(item => {
          return item.prop === item && item.type === 'cascader'
        })
        if (isCascader) { // 格式化级联数组，筛选最后节点
          formData[item] = formData[item].pop()
        }
      }
      return formData
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/tableUnit/components/search.vue